import { FormKit, FormKitSchema } from '@formkit/vue'
import { markRaw } from 'vue'

import IDSKButton from '../../components/base/button/IDSKButton/IDSKButton.vue'
import IDSKAccordion from '../../components/base/IDSKAccordion/IDSKAccordion.vue'
import IDSKAccordionSection from '../../components/base/IDSKAccordion/IDSKAccordionSection.vue'
import IDSKDetails from '../../components/base/IDSKDetails/IDSKDetails.vue'
import IDSKCheckbox from '../../components/inputs/IDSKCheckboxes/IDSKCheckbox.vue'
import IDSKCheckboxes from '../../components/inputs/IDSKCheckboxes/IDSKCheckboxes.vue'
import IDSKDragAndDrop from '../../components/inputs/IDSKDragAndDrop/IDSKDragAndDrop.vue'
import IDSKInput from '../../components/inputs/IDSKInput.vue'
import IDSKDateInputSeparated from '../../components/inputs/IDSKDateInputSeparated/IDSKDateInputSeparated.vue'
import IDSKTimeInput from '../../components/inputs/IDSKTimeInput.vue'
import IDSKDateTimeInput from '../../components/inputs/IDSKDateTimeInput.vue'
import IDSKRadios from '../../components/inputs/IDSKRadios/IDSKRadios.vue'
import IDSKTextarea from '../../components/inputs/IDSKTextarea.vue'
import PrilohyTable from '../../components/pages/zoppm/step0/PrilohyTable.vue'
import ZoppmKsPrilohyPredloha from '../../components/pages/zoppm/step0/ZoppmKsPrilohyPredloha.vue'
import ZoppmSsVyzvaIdentifikacia from '../../components/pages/zoppm/step0/ZoppmSsVyzvaIdentifikacia.vue'
import ZoppmSsVyzvaOrgany from '../../components/pages/zoppm/step0/ZoppmSsVyzvaOrgany.vue'
import ZoppmUxZiadostHlavicka from '../../components/pages/zoppm/step0/ZoppmUxZiadostHlavicka.vue'
import ZoppmUxZiadostPostup from '../../components/pages/zoppm/step0/ZoppmUxZiadostPostup.vue'
import ZoppmDsProjekt from '../../components/pages/zoppm/step1/ZoppmDsProjekt.vue'
import ZoppmSsProjekt from '../../components/pages/zoppm/step1/ZoppmSsProjekt.vue'
import ZoppmUxProjektHlavicka from '../../components/pages/zoppm/step1/ZoppmUxProjektHlavicka.vue'
import UploadedFilesTable from '../../components/pages/zoppm/step13/UploadedFilesTable.vue'
import PodmienkyPoskytnutia from '../../components/pages/zoppm/step2/PodmienkyPoskytnutia.vue'
import ZoppmKsPodmienkyOpravnenostZiadatela from '../../components/pages/zoppm/step2/ZoppmKsPodmienkyOpravnenostZiadatela.vue'
import ZoppmKsPodmienkyDorucenieZiadosti from '../../components/pages/zoppm/step2/ZoppmKsPodmienkyDorucenieZiadosti.vue'
import ZoppmKsPodmienkyDalsie from '../../components/pages/zoppm/step2/ZoppmKsPodmienkyDalsie.vue'
import ZoppmKsPodmienkyOsobitnePredpisy from '../../components/pages/zoppm/step2/ZoppmKsPodmienkyOsobitnePredpisy.vue'
import ZoppmKsPodmienkyStatnaPomoc from '../../components/pages/zoppm/step2/ZoppmKsPodmienkyStatnaPomoc.vue'
import ZoppmKsPodmienkyUcelPouzitia from '../../components/pages/zoppm/step2/ZoppmKsPodmienkyUcelPouzitia.vue'
import ZoppmUxPodmienkyHlavicka from '../../components/pages/zoppm/step2/ZoppmUxPodmienkyHlavicka.vue'
import ZoppmKsKriteria from '../../components/pages/zoppm/step3/ZoppmKsKriteria.vue'
import ZoppmUxKriteriaHlavicka from '../../components/pages/zoppm/step3/ZoppmUxKriteriaHlavicka.vue'
import ZoppmKsUkazovatele from '../../components/pages/zoppm/step4/ZoppmKsUkazovatele.vue'
import ZoppmUxUkazovateleHlavicka from '../../components/pages/zoppm/step4/ZoppmUxUkazovateleHlavicka.vue'
import ZoppmSsAktivity from '../../components/pages/zoppm/step5/ZoppmSsAktivity.vue'
import ZoppmUxAktivityHlavicka from '../../components/pages/zoppm/step5/ZoppmUxAktivityHlavicka.vue'
import ZoppmSsLokality from '../../components/pages/zoppm/step6/ZoppmSsLokality.vue'
import ZoppmUxLokalityHlavicka from '../../components/pages/zoppm/step6/ZoppmUxLokalityHlavicka.vue'
import ZoppmSsZiadatelFoBankoveSpojenie from '../../components/pages/zoppm/step7/fo/ZoppmSsZiadatelFoBankoveSpojenie.vue'
import ZoppmSsZiadatelFoIdentifikacia from '../../components/pages/zoppm/step7/fo/ZoppmSsZiadatelFoIdentifikacia.vue'
import ZoppmSsZiadatelFoKontaktnaOsoba from '../../components/pages/zoppm/step7/fo/ZoppmSsZiadatelFoKontaktnaOsoba.vue'
import ZoppmSsZiadatelFoKorespondencnaAdresa from '../../components/pages/zoppm/step7/fo/ZoppmSsZiadatelFoKorespondencnaAdresa.vue'
import ZoppmSsZiadatelFoTrvalyPobyt from '../../components/pages/zoppm/step7/fo/ZoppmSsZiadatelFoTrvalyPobyt.vue'
import ZoppmUxZiadatelFoHlavicka from '../../components/pages/zoppm/step7/fo/ZoppmUxZiadatelFoHlavicka.vue'
import ZoppmSsZiadatelPoBankoveSpojenie from '../../components/pages/zoppm/step7/po/ZoppmSsZiadatelPoBankoveSpojenie.vue'
import ZoppmSsZiadatelPoIdentifikacia from '../../components/pages/zoppm/step7/po/ZoppmSsZiadatelPoIdentifikacia.vue'
import ZoppmSsZiadatelPoKonecnyUzivatelVyhod from '../../components/pages/zoppm/step7/po/ZoppmSsZiadatelPoKonecnyUzivatelVyhod.vue'
import ZoppmSsZiadatelPoKontaktnaOsoba from '../../components/pages/zoppm/step7/po/ZoppmSsZiadatelPoKontaktnaOsoba.vue'
import ZoppmSsZiadatelPoKorespondencnaAdresa from '../../components/pages/zoppm/step7/po/ZoppmSsZiadatelPoKorespondencnaAdresa.vue'
import ZoppmSsZiadatelPoSidlo from '../../components/pages/zoppm/step7/po/ZoppmSsZiadatelPoSidlo.vue'
import ZoppmSsZiadatelPoStatutar from '../../components/pages/zoppm/step7/po/ZoppmSsZiadatelPoStatutar.vue'
import ZoppmUxZiadatelPoHlavicka from '../../components/pages/zoppm/step7/po/ZoppmUxZiadatelPoHlavicka.vue'
import ZoppmUxIneFormalneNalezitostiZiadostiHlavicka from '../../components/pages/zoppm/step8/ZoppmUxIneFormalneNalezitostiZiadostiHlavicka.vue'
import ZoppmDsZiadatel from '../../components/pages/zoppm/step8/ZoppmDsZiadatel.vue'
import ZoppmKsRozpocetSkutocne from '../../components/pages/zoppm/step9/ZoppmKsRozpocetSkutocne.vue'
import ZoppmUxRozpocetHlavicka from '../../components/pages/zoppm/step9/ZoppmUxRozpocetHlavicka.vue'
import ZoppmKsRozpocetZjednodusene from '../../components/pages/zoppm/step9/ZoppmKsRozpocetZjednodusene.vue'
import ZoppmKsRozpocetSumar from '../../components/pages/zoppm/step9/ZoppmKsRozpocetSumar.vue'
import ZoppmUxDoplnujuceUdajeRozpoctuHlavicka from '/@src/components/pages/zoppm/step10/ZoppmUxDoplnujuceUdajeRozpoctuHlavicka.vue'
import ZoppmDsRozpocet from '../../components/pages/zoppm/step10/ZoppmDsRozpocet.vue'
import ZoppmUxFinancovanieHlavicka from '../../components/pages/zoppm/step11/ZoppmUxFinancovanieHlavicka.vue'
import ZoppmSsFinancovanieSposob from '../../components/pages/zoppm/step11/ZoppmSsFinancovanieSposob.vue'
import ZoppmKsFinancovanieDeMinimis from '../../components/pages/zoppm/step11/ZoppmKsFinancovanieDeMinimis.vue'
import ZoppmSsFinancovaniePomoc from '../../components/pages/zoppm/step11/ZoppmSsFinancovaniePomoc.vue'
import ZoppmUxDalsieUdajeZiadostiHlavicka from '/@src/components/pages/zoppm/step12/ZoppmUxDalsieUdajeZiadostiHlavicka.vue'
import ZoppmDsZiadost from '../../components/pages/zoppm/step12/ZoppmDsZiadost.vue'
import ZoppmUxPrilohyHlavicka from '../../components/pages/zoppm/step13/ZoppmUxPrilohyHlavicka.vue'
import ZoppmUxPrilohyZozbieranie from '../../components/pages/zoppm/step13/ZoppmUxPrilohyZozbieranie.vue'
import ZoppmKsPrilohyPovinne from '../../components/pages/zoppm/step13/ZoppmKsPrilohyPovinne.vue'
import ZoppmSsPrilohyDalsie from '../../components/pages/zoppm/step13/ZoppmSsPrilohyDalsie.vue'
import ZoppmKsVyhlasenie from '../../components/pages/zoppm/step14/ZoppmKsVyhlasenie.vue'
import ZoppmSsPodpisovateliaPo from '../../components/pages/zoppm/step14/ZoppmSsPodpisovateliaPo.vue'
import ZoppmSsPodpisovateliaFo from '../../components/pages/zoppm/step14/ZoppmSsPodpisovateliaFo.vue'
import ZoppmUxVyhlasenieHlavicka from '../../components/pages/zoppm/step14/ZoppmUxVyhlasenieHlavicka.vue'
import ZoppmUxFinalizaciaHlavicka from '../../components/pages/zoppm/step16/ZoppmUxFinalizaciaHlavicka.vue'
import ZoppmUxFinalizaciaNahlad from '../../components/pages/zoppm/step16/ZoppmUxFinalizaciaNahlad.vue'
import ZoppmUxSposobPodanieHlavicka from '/@src/components/pages/zoppm/step17/ZoppmUxSposobPodanieHlavicka.vue'
import ZoppmUxSposobPodanieOznam from '/@src/components/pages/zoppm/step17/ZoppmUxSposobPodanieOznam.vue'
import ZoppmUxSposobPodanieTelo from '/@src/components/pages/zoppm/step17/ZoppmUxSposobPodanieTelo.vue'
import ZoppmUxPartnerFoHlavicka from '/@src/components/pages/zoppm/step18/fo/ZoppmUxPartnerFoHlavicka.vue'
import ZoppmSsPartnerFoBody from '/@src/components/pages/zoppm/step18/fo/ZoppmSsPartnerFoBody.vue'
import ZoppmUxPartnerPoHlavicka from '/@src/components/pages/zoppm/step18/po/ZoppmUxPartnerPoHlavicka.vue'
import ZoppmSsPartnerPoBody from '/@src/components/pages/zoppm/step18/po/ZoppmSsPartnerPoBody.vue'
import IDSKHeading from '../../components/typography/IDSKHeading.vue'
import IDSKParagraph from '../../components/typography/IDSKParagraph.vue'
import IDSKSelect from '../../components/inputs/IDSKSelect.vue'
import IDSKSection from '../../components/base/IDSKSection.vue'
import IDSKDivider from '../../components/base/IDSKDivider.vue'
import ValidationWrapper from '../../components/inputs/ValidationWrapper.vue'
import ValidationWrapperDynamic from '../../components/inputs/ValidationWrapperDynamic.vue'
import ZoppmUxZhrnutieHlavicka from '../../components/pages/zoppm/step15/ZoppmUxZhrnutieHlavicka.vue'
import ZoppmUxZhrnutiePoPrehlad from '../../components/pages/zoppm/step15/ZoppmUxZhrnutiePoPrehlad.vue'
import ZoppmUxZhrnutieFoPrehlad from '../../components/pages/zoppm/step15/ZoppmUxZhrnutieFoPrehlad.vue'
import DynamicSectionReadonly from '../../components/DynamicSectionReadonly.vue'
import DynamicCheckbox from '../../components/inputs/DynamicCheckbox.vue'
import ZoppmTitleInstructions from '/@src/components/pages/zoppm/ZoppmTitleInstructions.vue'

// rozpocet
import VydavokProjektu from '../../components/pages/zoppm/step9/VydavokProjektu.vue'

const library = markRaw({
  FormKit,
  FormKitSchema,
  IDSKInput,
  IDSKButton,
  IDSKTextarea,
  IDSKCheckbox,
  IDSKHeading,
  ZoppmSsVyzvaIdentifikacia,
  IDSKDetails,
  PrilohyTable,
  UploadedFilesTable,
  ZoppmKsUkazovatele,
  IDSKParagraph,
  IDSKRadios,
  IDSKCheckboxes,
  IDSKDragAndDrop,
  IDSKAccordion,
  IDSKAccordionSection,
  IDSKSection,
  IDSKSelect,
  IDSKDivider,
  IDSKDateInputSeparated,
  IDSKTimeInput,
  IDSKDateTimeInput,
  PodmienkyPoskytnutia,
  ZoppmUxZiadostHlavicka,
  ZoppmUxZiadostPostup,
  ZoppmSsVyzvaOrgany,
  ZoppmKsPrilohyPredloha,
  ZoppmSsProjekt,
  ZoppmDsProjekt,
  ZoppmUxProjektHlavicka,
  ZoppmUxPodmienkyHlavicka,
  ZoppmKsPodmienkyOpravnenostZiadatela,
  ZoppmKsPodmienkyUcelPouzitia,
  ZoppmKsPodmienkyDorucenieZiadosti,
  ZoppmKsPodmienkyDalsie,
  ZoppmKsPodmienkyOsobitnePredpisy,
  ZoppmKsPodmienkyStatnaPomoc,
  ZoppmUxKriteriaHlavicka,
  ZoppmKsKriteria,
  ZoppmUxUkazovateleHlavicka,
  ZoppmUxAktivityHlavicka,
  ZoppmSsAktivity,
  ZoppmUxLokalityHlavicka,
  ZoppmSsLokality,
  ZoppmUxZiadatelFoHlavicka,
  ZoppmSsZiadatelFoIdentifikacia,
  ZoppmSsZiadatelFoTrvalyPobyt,
  ZoppmSsZiadatelFoKorespondencnaAdresa,
  ZoppmSsZiadatelFoBankoveSpojenie,
  ZoppmSsZiadatelFoKontaktnaOsoba,
  ZoppmUxZiadatelPoHlavicka,
  ZoppmSsZiadatelPoIdentifikacia,
  ZoppmSsZiadatelPoSidlo,
  ZoppmSsZiadatelPoKorespondencnaAdresa,
  ZoppmSsZiadatelPoBankoveSpojenie,
  ZoppmSsZiadatelPoStatutar,
  ZoppmSsZiadatelPoKontaktnaOsoba,
  ZoppmSsZiadatelPoKonecnyUzivatelVyhod,
  ZoppmUxIneFormalneNalezitostiZiadostiHlavicka,
  ZoppmDsZiadatel,
  ZoppmUxRozpocetHlavicka,
  ZoppmKsRozpocetSkutocne,
  ZoppmKsRozpocetZjednodusene,
  ZoppmKsRozpocetSumar,
  ZoppmUxDoplnujuceUdajeRozpoctuHlavicka,
  ZoppmDsRozpocet,
  ZoppmUxFinancovanieHlavicka,
  ZoppmSsFinancovanieSposob,
  ZoppmKsFinancovanieDeMinimis,
  ZoppmSsFinancovaniePomoc,
  ZoppmUxDalsieUdajeZiadostiHlavicka,
  ZoppmDsZiadost,
  ZoppmKsVyhlasenie,
  ZoppmSsPodpisovateliaPo,
  ZoppmSsPodpisovateliaFo,
  ZoppmUxVyhlasenieHlavicka,
  ZoppmUxFinalizaciaHlavicka,
  ZoppmUxFinalizaciaNahlad,
  ZoppmUxSposobPodanieHlavicka,
  ZoppmUxSposobPodanieOznam,
  ZoppmUxSposobPodanieTelo,
  ZoppmUxPrilohyHlavicka,
  ZoppmUxPrilohyZozbieranie,
  ZoppmKsPrilohyPovinne,
  ZoppmSsPrilohyDalsie,
  ValidationWrapper,
  ValidationWrapperDynamic,
  ZoppmUxZhrnutieHlavicka,
  ZoppmUxZhrnutiePoPrehlad,
  ZoppmUxZhrnutieFoPrehlad,
  ZoppmUxPartnerFoHlavicka,
  DynamicSectionReadonly,
  ZoppmSsPartnerFoBody,
  DynamicCheckbox,
  VydavokProjektu,
  ZoppmTitleInstructions,
  ZoppmUxPartnerPoHlavicka,
  ZoppmSsPartnerPoBody,
})

export default library
